import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Target } from 'lucide-react';
import { Card, Pill, PrimaryButton } from './ui';
import { studentApi } from '../../pages/journey/journeyApi';

export const TargetRolePicker = ({ data: d, studentId, refresh }) => {
  const current = d.student.target_roles || [];
  const [options, setOptions] = useState([]);
  const [picked, setPicked] = useState(current);
  const [editing, setEditing] = useState(!current.length);
  useEffect(() => { studentApi('/role-options').then(setOptions); }, []);
  const locked = !!d.target_roles_confirmed;
  const toggle = (t) => setPicked(picked.includes(t) ? picked.filter((x) => x !== t) : picked.length < 3 ? [...picked, t] : picked);
  const save = async () => {
    try { await studentApi('/me/target-roles', { method: 'PUT', body: { student_id: studentId, titles: picked } }); toast.success('Target roles saved'); setEditing(false); refresh(); }
    catch (e) { toast.error(e.message); }
  };
  const shown = d.target_roles.map((t) => t.title);
  return (
    <Card className="lg:col-span-2" data-testid="target-role-picker">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="font-outfit font-semibold text-[#0b1f4d] flex items-center gap-2"><Target className="w-4 h-4 text-teal-600" /> My target roles</p>
        {locked ? <Pill className="bg-emerald-100 text-emerald-800" data-testid="target-roles-confirmed">Confirmed by your consultant</Pill>
          : !editing && <button onClick={() => setEditing(true)} className="text-sm font-semibold text-teal-700" data-testid="target-roles-edit-btn">Change</button>}
      </div>
      {!editing || locked ? (
        <div className="flex flex-wrap gap-2" data-testid="target-roles-list">{shown.length ? shown.map((t) => <Pill key={t} className="bg-[#0b1f4d] text-white">{t}</Pill>)
          : <span className="text-sm text-slate-500">Not chosen yet</span>}</div>
      ) : (<>
        <p className="text-sm text-slate-600 mb-4">Pick 2–3 roles you'd like to work towards. They can be closely related (e.g. Java Developer + Backend Developer). Your consultant will confirm them with you.</p>
        <div className="space-y-3 max-h-80 overflow-auto pr-1">
          {options.map((o) => (
            <div key={o.family}><p className="text-[11px] uppercase tracking-widest text-slate-400 mb-1.5">{o.family_title}</p>
              <div className="flex flex-wrap gap-1.5">{o.titles.map((t) => (
                <button key={t} onClick={() => toggle(t)} data-testid={`target-role-option-${t}`}
                  className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${picked.includes(t) ? 'bg-teal-500 text-white border-teal-500' : 'border-slate-200 hover:border-teal-400'}`}>{t}</button>))}</div></div>))}
        </div>
        <div className="flex items-center gap-3 mt-4">
          <PrimaryButton onClick={save} disabled={picked.length < 2} data-testid="target-roles-save-btn">Save {picked.length}/3 roles</PrimaryButton>
          {picked.length < 2 && <span className="text-xs text-slate-500">Choose at least 2</span>}
        </div>
      </>)}
    </Card>
  );
};
